module.exports = __webpack_public_path__ + "media/images/lb/244-1956999b4dc566074da6b7411933da90.svg";